import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("stilet_lang") || "en");
  const [token, setToken] = useState(() => localStorage.getItem("stilet_token") || null);
  const [user, setUser] = useState(null);

  useEffect(() => { localStorage.setItem("stilet_lang", lang); }, [lang]);

  useEffect(() => {
    if (!token) { setUser(null); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => { setToken(null); localStorage.removeItem("stilet_token"); setUser(null); });
  }, [token]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("stilet_token", r.data.access_token);
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("stilet_token");
    setToken(null); setUser(null);
  };

  return (
    <AppContext.Provider value={{ lang, setLang, token, user, login, logout, API }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
